import React, { useEffect, useState } from 'react'
import { MdAdd } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import config from '../../app-config'
import { fetch_checkin_sessions_by_event_id } from '../../api/eventAPI'
import notify from '../../utils/IANotification'
import Table from '../app-components/Table'
import { tidy_date } from '../../utils/helper'

export default function EventCheckIn() {
  const navigate = useNavigate()
  const event_id = new URLSearchParams(window.location.search).get('event_id')
  const [checkInSessionData, setCheckInSessionData] = useState([])

  useEffect(() => {
    fetchCheckInSessions()
  }, [])

  const fetchCheckInSessions = async () => {
    if (!event_id || event_id === "new") return
  const { data, error, message } = await fetch_checkin_sessions_by_event_id(event_id)
  if (error) return notify({ type: 'error', message })
  setCheckInSessionData(data)
  }

  const table_columns = [
    {
      header: "Name",
      accessor: "name",
    },
    {
      header: "Start Date",
      data: (row) => `${tidy_date(row.start_datetime)}`,
    },
    {
      header: "End Date",
      data: (row) => `${tidy_date(row.end_datetime)}`,
    },
  ]


  return (
    <div>
      <div className="btn-grp">
        <button className="button flex flex-row items-center gap-2"
          onClick={() => navigate(`/admin/events/details?state=check-in_detail&event_id=${event_id}&session_id=new`)}
        >
          <MdAdd />
          <span>Add Session</span>
        </button>
      </div>
      <Table
        className="mt-4"
        data={checkInSessionData}
        columns={table_columns}
        actions={(row) => {
          return (
            <>
              <button className="text-xs hover:underline"
                onClick={() => navigate(`/admin/events/details?state=check-in_detail&event_id=${event_id}&session_id=${row.id}`)}
              >
                View
              </button>
            </>
          )
        }}
      />

    </div>
  )
}
